import React, { useMemo } from "react";
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";

// Config
import featureFlagKeys from "../../config/featureFlagKeys";

// Hooks
import { useFeatureFlags } from "../../context/FeatureFlagsProvider";
import useTranslate from "../../hooks/useTranslate";

// Components
import Text from "../Text";

// Fields
import CountryField from "../CountryField";
import CustomField from "../CustomField";
import MiniMap from "../MiniMap/MiniMap";

const useStyles = makeStyles(theme => ({
  label: {
    marginBottom: theme.spacing(1.5)
  },
  phoneInputWrapper: {
    display: "flex",
    flexDirection: "row"
  }
}));

const VictimFormContent = ({ coord, errors, values }) => {
  const { featureFlags } = useFeatureFlags();
  const classes = useStyles();
  const getText = useTranslate();

  const fieldList = useMemo(
    () => [
      {
        label: getText("createCasePage.formContent.victimGivenNameLabel"),
        name: "givenName"
      },
      {
        label: getText("createCasePage.formContent.victimFamilyNameLabel"),
        name: "familyName"
      },
      {
        label: getText("createCasePage.formContent.victimBirthDateLabel"),
        name: "dateOfBirth",
        type: "date"
      }
    ],
    []
  );

  return (
    <>
      {fieldList.map(field => (
        <CustomField key={field.name} {...field} />
      ))}
      {featureFlags[featureFlagKeys.MINIMAP] && coord && (
        <MiniMap latitude={coord.lat()} longitude={coord.lng()} />
      )}
      <Text
        className={classes.label}
        text="createCasePage.formContent.victimPhoneNumberLabel"
        type="valueLabel"
      />
      <div className={classes.phoneInputWrapper}>
        <CountryField selectedCountryCode={values.country} />
        <CustomField
          error={errors.number}
          name="number"
          placeholder="(0) 777122435"
        />
      </div>
    </>
  );
};

VictimFormContent.propTypes = {
  errors: PropTypes.shape({
    number: PropTypes.string
  }).isRequired,
  values: PropTypes.shape({
    country: PropTypes.string
  }).isRequired,
  coord: PropTypes.shape({ lat: PropTypes.func, lng: PropTypes.func })
};

VictimFormContent.defaultProps = {
  coord: null
};

export default VictimFormContent;
